import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

const QuestionSubTitle = ({ label, children, sx = {} }) => {
  return (
    <div className="mb-1 flex w-full items-center justify-between gap-8">
      <Typography
        fontWeight="medium"
        mb={0.5}
        sx={{
          ...sx,
          color: HNSColors.neutrals[100],
          fontWeight: "500",
          fontSize: "12px",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        {label}
      </Typography>
      {children}
    </div>
  );
};

export default QuestionSubTitle;
